// Coverage counts for copy, e.g. `${COVERAGE.chains} chains`.
// Builds overwrite this file with tooling/coverage-stats/refresh.mts. The committed
// values are the fallback: 303 chains, 1,523 apps, 14,302 tokenized assets.
export const COVERAGE = {
  chains: "300+",
  apps: "1,500+",
  tokenizedAssets: "14,000+",
} as const
